import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";

import TopBar from "./TopBar";

export default function DashboardLayout() {
    const location = useLocation();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '100vh' }}>
            <TopBar />
            <Box
                component="main"
                sx={{
                    width: '100%',
                    flexGrow: 1,
                    marginTop: '70px',
                    p: { xs: 2, sm: 4, md: 6 },
                    transition: 'all 0.3s ease-in-out',
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
}